import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface fakeInputProps {
  title: string
  subtitle?: string
  hasChevron?: boolean
}

const FakeInput = ({ title, subtitle, hasChevron = false }: fakeInputProps) => {
  return (
    <Box
      flexDirection="row"
      borderRadius={{
        all: 'abs008',
      }}
      paddingX="s16"
      paddingY="s6"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey600',
        },
      }}
    >
      <Box gap="s4" flexDirection="row" alignItems="center">
        <Text.Normal weight="medium">{title}</Text.Normal>
        {subtitle && (
          <Text.Normal color="grey600" weight="medium">
            {subtitle}
          </Text.Normal>
        )}

        {hasChevron && (
          <Box paddingLeft="s4">
            <Icon.Small color="grey1000" icon="caret-down" />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default FakeInput
